import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiDownload,
  FiCalendar,
  FiUser,
  FiFileText,
  FiShield,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function AuditLogs() {
  const [searchTerm, setSearchTerm] = useState("");
  const [actionFilter, setActionFilter] = useState("all");
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [logs] = useState([
    {
      id: 1,
      timestamp: "2024-01-20 10:30:15",
      userId: "USR-001",
      userName: "Admin-001",
      action: "User Created",
      resource: "User",
      resourceId: "USR-010",
      ipAddress: "192.168.1.100",
      status: "Success",
    },
    {
      id: 2,
      timestamp: "2024-01-20 09:15:22",
      userId: "USR-002",
      userName: "Admin-002",
      action: "KYC Approved",
      resource: "KYC",
      resourceId: "KYC-005",
      ipAddress: "192.168.1.101",
      status: "Success",
    },
    {
      id: 3,
      timestamp: "2024-01-19 16:45:30",
      userId: "USR-003",
      userName: "Admin-001",
      action: "Content Published",
      resource: "Content",
      resourceId: "CNT-003",
      ipAddress: "192.168.1.100",
      status: "Success",
    },
    {
      id: 4,
      timestamp: "2024-01-19 14:20:10",
      userId: "USR-001",
      userName: "Admin-001",
      action: "Login",
      resource: "Authentication",
      resourceId: null,
      ipAddress: "192.168.1.100",
      status: "Success",
    },
  ]);

  const handleExport = () => {
    Swal.fire({
      title: "Export Audit Logs",
      html: `
        <input id="startDate" class="swal2-input" type="date" placeholder="Start Date" required>
        <input id="endDate" class="swal2-input" type="date" placeholder="End Date" required>
        <select id="format" class="swal2-select">
          <option value="csv">CSV</option>
          <option value="pdf">PDF</option>
          <option value="excel">Excel</option>
        </select>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Export",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Exporting...", "Audit logs export initiated.", "info");
      }
    });
  };

  const filteredLogs = logs.filter((log) => {
    const matchesSearch =
      log.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.action.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.resource.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesAction = actionFilter === "all" || log.action === actionFilter;
    return matchesSearch && matchesAction;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredLogs.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredLogs.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                <div className="content-page-header content-page-headersplit">
                <h5>Audit Logs</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/security/audit-logs">Security</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Audit Logs
                  </li>
                </ol>
              </nav>
            
           
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                <div className="d-flex justify-content-between align-items-center flex-wrap"> {/* Filters */} 
                  <div className="row g-2 flex-grow-1">
                <div className="col-12 col-md-4">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by user, action, or resource..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={actionFilter}
                    onChange={(e) => {
                      setActionFilter(e.target.value);
                      setCurrentPage(0);
                    }}
                  >
                    <option value="all">All Actions</option>
                    <option value="User Created">User Created</option>
                    <option value="KYC Approved">KYC Approved</option>
                    <option value="Content Published">Content Published</option>
                    <option value="Login">Login</option>
                  </select>
                </div>
                <div className="col-12 col-md-2">
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Start Date"
                    value={dateRange.start}
                    onChange={(e) => {
                      setDateRange({ ...dateRange, start: e.target.value });
                      setCurrentPage(0);
                    }}
                  />
                </div>
                <div className="col-12 col-md-2">
                  <input
                    type="date"
                    className="form-control"
                    placeholder="End Date"
                    value={dateRange.end}
                    onChange={(e) => {
                      setDateRange({ ...dateRange, end: e.target.value });
                      setCurrentPage(0);
                    }}
                  />
                </div>
                </div>
                <div className="ms-md-3 mt-3 mt-md-0">
                  <button
                    className="btn btn-primary"
                    onClick={handleExport}
                  >
                    <i className="fas fa-download me-2"></i>
                    Export Logs
                  </button>
                </div>
              </div>
            </div>

            {/* Logs Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Timestamp</th>
                          <th>User</th>
                          <th>Action</th>
                          <th>Resource</th>
                          <th>Resource ID</th>
                          <th>IP Address</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="7">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((log) => (
                            <tr key={log.id}>
                              <td style={{ fontSize: "14px" }}>{log.timestamp}</td>
                              <td style={{ fontWeight: "500" }}>{log.userName}</td>
                              <td style={{ fontWeight: "500" }}>{log.action}</td>
                              <td>
                                <span className="badge" style={{
                                  background: "#f0f9ff",
                                  color: "#006e82",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}>
                                  {log.resource}
                                </span>
                              </td>
                              <td>{log.resourceId || "-"}</td>
                              <td style={{ fontFamily: "monospace" }}>{log.ipAddress}</td>
                              <td>
                                <span className={log.status === "Success" ? "badge-active" : "badge-pending"}>
                                  {log.status}
                                </span>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
